// GuaranteeSummary.js (for custom orders)
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';

const GuaranteeSummary = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`/api/orders/guarantee-summary/${orderId}`)
      .then(res => {
        setOrder(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, [orderId]);

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto pt-20 p-6">
        <div className="h-6 bg-gray-200 rounded w-1/3 mb-4 animate-pulse"></div>
        <div className="mt-4 grid grid-cols-4 gap-6 animate-pulse">
          {Array(4).fill().map((_, idx) => (
            <div key={idx} className="space-y-2 col-span-1">
              <div className="w-full h-16 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }
    if (!order) return <p className="p-6">Order not found.</p>;

  return (
    <div className="max-w-4xl mx-auto pt-20 p-6 bg-white shadow-md rounded-md border">
      <style>{`
        @media print {
          .no-print { display: none !important; }
          @page { size: A5 landscape; margin: 0; }
          body { margin: 0; }
        }
      `}</style>

      <h1 className="text-2xl font-bold text-center mb-6 text-gray-800">Custom Order Guarantee Summary</h1>

      <div className="overflow-x-auto">
        <table className="w-full text-sm border border-collapse rounded">
          <thead className="bg-gray-100 text-left">
            <tr>
              <th className="border px-3 py-2">Product ID</th>
              <th className="border px-3 py-2">Product Name</th>
              <th className="border px-3 py-2">Guarantee</th>
              <th className="border px-3 py-2 text-center">View</th>
            </tr>
          </thead>
          <tbody>
            {order.products.map(product => (
              <tr key={product.productId} className="hover:bg-gray-50">
                <td className="border px-3 py-2">{product.productId}</td>
                <td className="border px-3 py-2">{product.modelName}</td>
                <td className="border px-3 py-2 capitalize">{product.guarantee}</td>
                <td className="border px-3 py-2 text-center">
                  <Link
                    to={`/guarantee/${order.orderId}?productId=${product.productId}`}
                    className="text-blue-600 hover:underline"
                  >
                    View Guarantee
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center mt-6">
        <button
          onClick={() => window.print()}
          className="no-print bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
        >
          Print Summary
        </button>
      </div>
    </div>
  );

};

export default GuaranteeSummary;